import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconSignCancel } from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { NgModule } from '@angular/core';
import { ToolTipComponent } from './tool-tip.component';

@NgModule({
	imports: [
		CommonModule,
		HomefieldIconLibraryModule,
		HtmlSanitizerPipe
	],
	declarations: [ToolTipComponent],
	exports: [ToolTipComponent]
})
export class ToolTipModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel]);
	}
}
